export const FRAME_EXTENT_CIRCLE_SEGMENTS = 64;
export const EXTRUDED_PROFILE_SURFACE_BIAS = 0.003;
